import Cookies from 'universal-cookie';
import API from '../../services/orderService/api';
import CONSTANTS from '../../configs/constants';

const cookies = new Cookies();

export const setOrders = orders => ({
  type: 'SET_ORDERS',
  orders,
});

export const setOrderDetails = orderDetails => ({
  type: 'SET_ORDER_DETAILS',
  orderDetails,
});

export const OrdersError = error => ({
  type: 'SET_ORDERS_ERROR',
  error,
});

const handleError = (error, err, dispatch) => {
  if (error.response && error.response.status === 401) {
    if (typeof cookies.get(CONSTANTS.SSO_COOKIE_NAME) !== 'undefined') {
      cookies.remove(CONSTANTS.SSO_COOKIE_NAME, { domain: '.bestway.co.uk', path: '/' });
      window.location.href = error.response.headers.location;
    }
  } else {
    dispatch(err(error));
  }
};

export const getOrders = (
  set = setOrders,
  api = API,
  err = OrdersError,
) => dispatch =>
  api.getOrders()
    .then((response) => {
      if (response) {
        dispatch(set(response.data));
      }
    })
    .catch(error => {
      handleError(error, err, dispatch);
    });


export const getOrderDetails = (
  transactionId,
  set = setOrderDetails,
  api = API,
  err = OrdersError,
) => dispatch =>
  api.getOrderDetails(transactionId)
    .then((response) => {
      if (response) {
        dispatch(set(response.data));
      }
    })
    .catch(error => {
      handleError(error, err, dispatch);
    });



// WEBPACK FOOTER //
// src/redux/actions/orderActions.js